// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_banner__Muz\\+9 {
  background: rgb(117, 83, 240);
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.style_banner__title__XeSvE {
  margin: 10px 0;
  font-weight: 500;
  font-size: 1.6rem;
  color: rgb(247, 246, 255);
  position: relative;
  z-index: 9;
}
.style_banner__sunshine__gK\\+3S {
  position: absolute;
  top: 35%;
  left: 51%;
  transform: translate(-50%, -50%);
  width: 100vw;
  z-index: 0;
}
.style_banner__sunshine__gK\\+3S img {
  animation: style_rotate__4QfbK 20s linear infinite;
}
.style_banner__confetti__NDYTi {
  position: absolute;
  top: 28%;
  left: 51%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 0;
}
.style_banner__confetti__NDYTi img {
  width: 100%;
  height: 100%;
}
.style_banner__images__YLvNy {
  display: flex;
  justify-content: center;
  position: relative;
}
.style_banner__images__YLvNy img {
  position: relative;
  z-index: 9;
}
.style_banner__trophy__-9kYh {
  width: 115px;
  height: 115px;
}
.style_banner__trophy__image__vE42D {
  width: 115px;
  position: relative;
  z-index: 9;
}
.style_banner__trophy__-9kYh img {
  width: 100%;
  height: 100%;
}
.style_banner__timer__CSPRs {
  position: relative;
  padding: 6px 12px;
  line-height: 20px;
  border-radius: 20px;
  background: rgb(85, 46, 224);
  color: rgb(255, 255, 255);
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  gap: 4px;
  min-width: 220px;
}

.style_finished__8vavP {
  padding-top: 11px;
  padding-bottom: 26px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 17px;
  color: rgb(255, 255, 255);
  position: relative;
}

.style_rules__D3738 {
  padding-top: 11px;
  padding-bottom: 31px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 13px;
  align-items: center;
  max-width: 300px;
}
.style_rules__description__doI4j {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 17px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
}
.style_rules__reward__\\+Bcfd {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 18px;
}

@keyframes style_rotate__4QfbK {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/components/clan-wars-banner/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BCHK;EDIL,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAEE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,UAAA;AADJ;AAEI;EACE,kDAAA;AAAN;AAIE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,UAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAKE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAHJ;AAII;EACE,kBAAA;EACA,UAAA;AAFN;AAKE;EACE,YAAA;EACA,aAAA;AAHJ;AAII;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AAFN;AAII;EACE,WAAA;EACA,YAAA;AAFN;AAME;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBCpEI;EDqEJ,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBCrFM;EDsFN,kBAAA;AALF;;AAQA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AALF;AAOE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AALJ;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;;AAUA;EACE;IACE,uBAAA;EAPF;EASA;IACE,yBAAA;EAPF;AACF","sourcesContent":["@import '../../../../../public/assets/colors';\n\n.banner {\n  background: $main;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  &__title {\n    margin: 10px 0;\n    font-weight: 500;\n    font-size: 1.6rem;\n    color: rgba(247, 246, 255, 1);\n    position: relative;\n    z-index: 9;\n  }\n\n  &__sunshine {\n    position: absolute;\n    top: 35%;\n    left: 51%;\n    transform: translate(-50%, -50%);\n    width: 100vw;\n    z-index: 0;\n    img {\n      animation: rotate 20s linear infinite;\n    }\n  }\n\n  &__confetti {\n    position: absolute;\n    top: 28%;\n    left: 51%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    z-index: 0;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__images {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    img {\n      position: relative;\n      z-index: 9;\n    }\n  }\n  &__trophy {\n    width: 115px;\n    height: 115px;\n    &__image {\n      width: 115px;\n      position: relative;\n      z-index: 9;\n    }\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__timer {\n    position: relative;\n    padding: 6px 12px;\n    line-height: 20px;\n    border-radius: 20px;\n    background: rgba(85, 46, 224, 1);\n    color: $white;\n    font-size: 1.6rem;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n    min-width: 220px;\n  }\n}\n\n.finished {\n  padding-top: 11px;\n  padding-bottom: 26px;\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 500;\n  line-height: 17px;\n  color: $white;\n  position: relative;\n}\n\n.rules {\n  padding-top: 11px;\n  padding-bottom: 31px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n  align-items: center;\n  max-width: 300px;\n\n  &__description {\n    font-size: 1.4rem;\n    font-weight: 500;\n    line-height: 17px;\n    color: rgba(255, 255, 255, 0.75);\n    text-align: center;\n  }\n\n  &__reward {\n    font-size: 1.8rem;\n    font-weight: 700;\n    line-height: 18px;\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `style_banner__Muz+9`,
	"banner__title": `style_banner__title__XeSvE`,
	"banner__sunshine": `style_banner__sunshine__gK+3S`,
	"rotate": `style_rotate__4QfbK`,
	"banner__confetti": `style_banner__confetti__NDYTi`,
	"banner__images": `style_banner__images__YLvNy`,
	"banner__trophy": `style_banner__trophy__-9kYh`,
	"banner__trophy__image": `style_banner__trophy__image__vE42D`,
	"banner__timer": `style_banner__timer__CSPRs`,
	"finished": `style_finished__8vavP`,
	"rules": `style_rules__D3738`,
	"rules__description": `style_rules__description__doI4j`,
	"rules__reward": `style_rules__reward__+Bcfd`
};
export default ___CSS_LOADER_EXPORT___;
